export default (
  parsedQuotaCounts,
  userAgeFilter,
  genderMaxInTheory,
  survey
) => {
  const quotas = {
    count: 0,
    maxInTheory: 0,
    remainingPlaces: false,
    gender: {
      Male: {
        count: 0,
        maxInTheory: 0,
        remainingPlaces: false
      },
      Female: {
        count: 0,
        maxInTheory: 0,
        remainingPlaces: false
      },
      Other: {
        count: 0,
        maxInTheory: 0,
        remainingPlaces: false
      }
    }
  };

  const getMaxInTheoryResponses = (max, type, maxResponses) => {
    if (type === '%') {
      return (max / 100) * maxResponses;
    }
    return max;
  };

  if (
    parsedQuotaCounts &&
    parsedQuotaCounts.age &&
    userAgeFilter &&
    userAgeFilter.age
  ) {
    const startRangeAge =
      userAgeFilter.age.$gte !== undefined
        ? userAgeFilter.age.$gte
        : userAgeFilter.age.$gt + 1;
    const endRangeAge =
      userAgeFilter.age.$lte !== undefined
        ? userAgeFilter.age.$lte
        : userAgeFilter.age.$lt - 1;

    for (let i = startRangeAge; i <= endRangeAge; i += 1) {
      if (parsedQuotaCounts.age[i]) {
        const ageQuota = parsedQuotaCounts.age[i];

        quotas.count += ageQuota.count;
        if (userAgeFilter && userAgeFilter.$dynamic) {
          quotas.maxInTheory = getMaxInTheoryResponses(
            userAgeFilter.$dynamic.$max,
            userAgeFilter.$dynamic.$type,
            survey.maxResponses
          );

          if (quotas.maxInTheory - quotas.count > 1) {
            quotas.remainingPlaces = true;
          } else {
            quotas.remainingPlaces = false;
          }
        }

        if (ageQuota && ageQuota.crossed && ageQuota.crossed.gender) {
          const genderQuota = ageQuota.crossed.gender;
          if (genderQuota.Male) {
            quotas.gender.Male.count += genderQuota.Male.count;
          }
          if (genderQuota.Female) {
            quotas.gender.Female.count += genderQuota.Female.count;
          }
          if (genderQuota.Other) {
            quotas.gender.Other.count += genderQuota.Other.count;
          }
        }
      }
    }

    // Max In Theory gender per ages
    if (quotas.gender && Object.keys(genderMaxInTheory).length) {
      if (quotas.gender.Male) {
        quotas.gender.Male.maxInTheory = getMaxInTheoryResponses(
          genderMaxInTheory.Male.maxValue,
          genderMaxInTheory.Male.maxType,
          quotas.maxInTheory
        );

        if (quotas.gender.Male.maxInTheory - quotas.gender.Male.count > 1) {
          quotas.gender.Male.remainingPlaces = true;
        }
      }
      if (quotas.gender.Female) {
        quotas.gender.Female.maxInTheory = getMaxInTheoryResponses(
          genderMaxInTheory.Female.maxValue,
          genderMaxInTheory.Female.maxType,
          quotas.maxInTheory
        );

        if (quotas.gender.Female.maxInTheory - quotas.gender.Female.count > 1) {
          quotas.gender.Female.remainingPlaces = true;
        }
      }
      if (quotas.gender.Other) {
        quotas.gender.Other.maxInTheory = getMaxInTheoryResponses(
          genderMaxInTheory.Other.maxValue,
          genderMaxInTheory.Other.maxType,
          quotas.maxInTheory
        );

        if (quotas.gender.Other.maxInTheory - quotas.gender.Other.count > 1) {
          quotas.gender.Other.remainingPlaces = true;
        }
      }
    }
  }

  return quotas;
};
